import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { captureException } from '@sentry/react';

import { SingleSelectDropdown } from '../../../components/select-dropdown';

import styles from './country-select.module.scss';
interface Props {
  onChange: (value: string) => void;
  value?: string;
}

interface Option {
  label: string;
  value: string;
}

export const CountrySelect: React.FC<Props> = ({ onChange, value }) => {
  const [options, setOptions] = useState<Option[]>([]);

  useEffect(() => {
    axios
      .get(`${window.location.origin}/countries.json`)
      .then(({ data }) => {
        setOptions(
          data.map((country: any) => ({
            label: country.name,
            value: country.code,
          })),
        );
      })
      .catch(captureException);
  }, []);

  const handleChange = (value?: string) => {
    onChange(value || '');
  };

  return (
    <div className={styles['container']}>
      <SingleSelectDropdown
        title={'Country'}
        value={value}
        options={options}
        onValueChange={handleChange}
        placeholder="Choose a country..."
      />
    </div>
  );
};
